import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './PaymentCancelledPage.scss';
import { localStore } from '../../components/utils/safeStorage';

const PaymentCancelledPage: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [redirectUrl, setRedirectUrl] = useState<string>('/');
  
  useEffect(() => {
    // Get the return URL from localStorage or default to home
    const returnUrl = localStore.getItem('stripe_return_url') || '/';
    localStore.removeItem('stripe_return_url'); // Clean up
    
    console.log('PaymentCancelledPage - Return URL from localStorage:', returnUrl);
    
    // Parse the URL to check what parameters it has
    try {
      const urlObj = new URL(returnUrl, window.location.origin);
      console.log('PaymentCancelledPage - URL params before adding payment:', Array.from(urlObj.searchParams.entries()));
    } catch (e) {
      console.error('Failed to parse return URL:', e);
    }
    
    // Add payment=cancelled parameter to the return URL
    let finalRedirectUrl: string;
    if (returnUrl.includes('?')) {
      // URL already has query params, append payment param
      finalRedirectUrl = `${returnUrl}&payment=cancelled`;
    } else {
      // No query params yet, add payment param
      finalRedirectUrl = `${returnUrl}?payment=cancelled`;
    }
    
    console.log('PaymentCancelledPage - Final redirect URL:', finalRedirectUrl);
    setRedirectUrl(finalRedirectUrl);
    
    // Redirect after 5 seconds
    const timer = setTimeout(() => {
      history.push(finalRedirectUrl);
    }, 5000);
    
    return () => clearTimeout(timer);
  }, [history]);
  
  return (
    <div className="payment-cancelled-page">
      <div className="payment-cancelled-page__container">
        <div className="payment-cancelled-page__content">
          <div className="payment-cancelled-page__icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6l12 12" stroke="#ff5252" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="12" cy="12" r="9" stroke="#ff5252" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          
          <h1 className="payment-cancelled-page__title">
            {t('payment.cancelled.title', { defaultValue: 'Payment Cancelled' })}
          </h1>
          
          <p className="payment-cancelled-page__message">
            {t('payment.cancelled.message', { 
              defaultValue: 'Your purchase was cancelled. No charges were made to your payment method.',
            })}
          </p>
          
          <p className="payment-cancelled-page__info">
            {t('payment.cancelled.info', {
              defaultValue: 'You can purchase enhancement credits anytime from the image upload section when creating a listing.',
            })}
          </p>
          
          <p className="payment-cancelled-page__redirect">
            {t('payment.cancelled.redirecting', {
              defaultValue: 'Redirecting you back to the app...',
            })}
          </p>
          
          <button
            className="payment-cancelled-page__button"
            onClick={() => history.push(redirectUrl)}
          >
            {t('payment.cancelled.continueButton', { defaultValue: 'Back to App' })}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelledPage;
